<mat-card>
  <mat-card-content>
    <div class="search-form" fxLayout="row wrap" fxFlexAlign="center" fxLayout="column">
      <mat-form-field class="accent" fxFlex.gt-sm="100" fxFlex="100" class="p-10">
        <mat-label>Search</mat-label>
        <input matInput type="text" [(ngModel)]="search" name="search" (keyup.enter)="loadData()"
          (keyup.esc)="search=''; loadData()">
        <button mat-button *ngIf="search" matSuffix mat-icon-button aria-label="Clear" (click)="search=''">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <div>
        <mat-form-field fxFlex="100" fxFlex.gt-sm="50" class="p-10">
          <mat-label>From</mat-label>
          <input matInput [matDatepicker]="matDateFrom" [(ngModel)]="dateFrom" name="dateFrom">
          <mat-datepicker-toggle matSuffix [for]="matDateFrom"></mat-datepicker-toggle>
          <mat-datepicker #matDateFrom>
            <mat-datepicker-actions>
              <button mat-stroked-button color="basic" matDatepickerCancel>
                <mat-icon>clear</mat-icon> Cancel
              </button>
              <button mat-flat-button color="primary" matDatepickerApply>
                <mat-icon>done</mat-icon> Apply
              </button>
            </mat-datepicker-actions>
          </mat-datepicker>
        </mat-form-field>

        <mat-form-field fxFlex.gt-sm="50" fxFlex="100" class="p-10">
          <mat-label>To</mat-label>
          <input matInput [matDatepicker]="matDateTo" [(ngModel)]="dateTo" name="dateTo">
          <mat-datepicker-toggle matSuffix [for]="matDateTo"></mat-datepicker-toggle>
          <mat-datepicker #matDateTo>
            <mat-datepicker-actions>
              <button type="button" mat-stroked-button color="basic" matDatepickerCancel>
                <mat-icon>clear</mat-icon> Cancel
              </button>
              <button type="button" mat-flat-button color="primary" matDatepickerApply>
                <mat-icon>done</mat-icon> Apply
              </button>
            </mat-datepicker-actions>
          </mat-datepicker>
        </mat-form-field>

        <mat-form-field fxFlex.gt-sm="16.66666" fxFlex="100" class="p-10">
          <mat-label>Type</mat-label>
          <mat-select [(value)]="type" name="type">
            <mat-option value="">All</mat-option>
            <mat-option value="home">Home</mat-option>
            <mat-option value="room">Room</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field fxFlex.gt-sm="16.66666" fxFlex="100" class="p-10">
          <mat-label>Result</mat-label>
          <mat-select [(value)]="result" name="result">
            <mat-option value="">All</mat-option>
            <mat-option value="success">Success</mat-option>
            <mat-option value="failed">Failed</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="accent" fxFlex.gt-sm="16.66666" fxFlex="100" class="p-10">
          <mat-label>Min Wait</mat-label>
          <input matInput type="number" [(ngModel)]="wait" name="minWait">
          <button mat-button *ngIf="wait" matSuffix mat-icon-button aria-label="Clear" (click)="wait=undefined">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <mat-form-field class="accent" fxFlex.gt-sm="16.66666" fxFlex="100" class="p-10">
          <mat-label>Min Total</mat-label>
          <input matInput type="number" [(ngModel)]="total" name="minTotal">
          <button mat-button *ngIf="total" matSuffix mat-icon-button aria-label="Clear" (click)="total=undefined">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="end center">
        <button mat-flat-button color="primary" (click)="loadData()">
          <mat-icon>search</mat-icon> Search
        </button>
        <button mat-flat-button color="primary" (click)="downloadCsv()">
          <mat-icon>done</mat-icon> Save as CSV
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card class="scroll-x" *ngIf="logItems.length">
  <table mat-table [dataSource]="logItems" fxFill class="no-hover-highlight">
    <ng-container matColumnDef="dateStart">
      <th mat-header-cell *matHeaderCellDef> Date Start </th>
      <td mat-cell *matCellDef="let item"> {{item.dateAdded | date:'short'}} </td>
    </ng-container>

    <ng-container matColumnDef="dateEnd">
      <th mat-header-cell *matHeaderCellDef> Date End </th>
      <td mat-cell *matCellDef="let item"> {{item.dateCompleted | date:'short'}} </td>
    </ng-container>

    <ng-container matColumnDef="clientIp">
      <th mat-header-cell *matHeaderCellDef> Ip Address </th>
      <td mat-cell *matCellDef="let item"> {{item.clientIp}} </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef> Type </th>
      <td mat-cell *matCellDef="let item"> {{item.type}} </td>
    </ng-container>

    <ng-container matColumnDef="configuration">
      <th mat-header-cell *matHeaderCellDef> Configuration </th>
      <td mat-cell *matCellDef="let item"> {{item.homeName + ", " + item.masterFile + ", " + item.options + ", " +
        item.themes}}</td>
    </ng-container>

    <ng-container matColumnDef="room">
      <th mat-header-cell *matHeaderCellDef> Room </th>
      <td mat-cell *matCellDef="let item"> {{item.room}} </td>
    </ng-container>

    <ng-container matColumnDef="renderIp">
      <th mat-header-cell *matHeaderCellDef> Render Ip </th>
      <td mat-cell *matCellDef="let item"> {{item.renderIp}} </td>
    </ng-container>

    <ng-container matColumnDef="wait">
      <th mat-header-cell *matHeaderCellDef> Wait </th>
      <td mat-cell *matCellDef="let item"> {{item.waitTimeInSeconds | number:'1.0-0'}} </td>
    </ng-container>

    <ng-container matColumnDef="total">
      <th mat-header-cell *matHeaderCellDef> Total Time </th>
      <td mat-cell *matCellDef="let item"> {{item.totalTimeInSeconds | number:'1.0-0'}} </td>
    </ng-container>

    <ng-container matColumnDef="result">
      <th mat-header-cell *matHeaderCellDef> Result </th>
      <td mat-cell *matCellDef="let item"> {{item.result}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageSizeOptions]="[25, 50, 100]"
    (page)="onPageChange($event)">
  </mat-paginator>
</mat-card>
<mat-card *ngIf="!logItems.length">
  <mat-card-content>
    <p fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="center center">
      No data found
    </p>
  </mat-card-content>
</mat-card>